import clsx from 'clsx'
import { useFormikContext } from 'formik'
import PropTypes from 'prop-types'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  FormikMultiSelect,
  FormikSingleSelect,
  FormikTextField,
  FormikToggleCheckbox,
} from '../../../../../../../../components/FormikFields'
import { PW_MANAGER_SELECT_PROPS } from '../../../../../../../../util/inputAttrs'
import PasswordSettingsSection from '../../../../../modals/common/PasswordSettingsSection'
import { FORM_FIELDS } from '../../../../../modals/common/PasswordSettingsSection/fieldset'
import styles from './AddUserAccountTab.module.scss'

const propTypes = {
  selectedEmployee: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  domainOptions: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  groupOptions: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  employeeEmailOptions: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  autoGeneratedPassword: PropTypes.string.isRequired,
  canSkipPasswordReset: PropTypes.bool,
}

function AddUserAccountTab({
  selectedEmployee = null,
  domainOptions = [],
  groupOptions = [],
  employeeEmailOptions,
  autoGeneratedPassword,
  canSkipPasswordReset = false,
}) {
  const intl = useIntl()
  const { values, setFieldValue } = useFormikContext()
  const hasExistingGwsAccount = Boolean(selectedEmployee?.employeeIdentifier)

  return (
    <>
      <div className="text-strong mb-4">
        <FormattedMessage id="USERS.USERNAME" />
      </div>

      <div className="ms-3 me-3">
        {hasExistingGwsAccount && <p className="font-bolder mb-3">{selectedEmployee.email}</p>}

        {!hasExistingGwsAccount && (
          <Row className="mb-2 align-items-start">
            <Col md="6" className={styles.atDomainCharWrapper}>
              <FormikTextField
                id="username"
                title="ENGAGE.CREATE_USERNAME"
                placeholder={intl.formatMessage({ id: 'PLACEHOLDER.ENTER_USERNAME' })}
                required
                disablePasswordManager
              />
              <div className={clsx('text-bold', styles.atDomainChar)}>@</div>
            </Col>
            <Col md="6">
              <FormikSingleSelect
                id="domain"
                title="ENGAGE.ONBOARD.DOMAIN"
                titleClassName="invisible"
                defaultLabel={intl.formatMessage({ id: 'PLACEHOLDER.SELECT_DOMAIN' })}
                options={domainOptions}
                {...PW_MANAGER_SELECT_PROPS}
              />
            </Col>
          </Row>
        )}
      </div>

      <div className="ms-3 me-3 mb-3">
        <FormikToggleCheckbox
          id="isResettingPassword"
          disabled={!canSkipPasswordReset}
          label={<FormattedMessage id="ENGAGE.RESET_PASSWORD" />}
          className="checkbox-left-aligned"
          onChange={(isResetting) => {
            if (!isResetting) {
              setFieldValue(FORM_FIELDS.IS_AUTO_GENERATING_PASSWORD, true)
              setFieldValue(FORM_FIELDS.NEW_PASSWORD, autoGeneratedPassword)
              setFieldValue(FORM_FIELDS.IS_SENDING_PASSWORD_TO_ME, true)
            }
          }}
        />
      </div>

      {values.isResettingPassword && (
        <PasswordSettingsSection
          autoGeneratedPassword={autoGeneratedPassword}
          employeeEmailOptions={employeeEmailOptions}
          fullWidth
        />
      )}

      <div className="text-strong mb-4">
        <FormattedMessage id="ENGAGE.GROUPS" />
      </div>
      <div className="ms-3 me-3">
        {/* The modal body is a PerfectScrollbar (overflow hidden), so an inline menu at the bottom of the tab is
            clipped and react-select scrolls the wrong ancestor to reveal it. Portal it to the body instead. */}
        <FormikMultiSelect
          id="groups"
          title="ENGAGE.ADD_TO_GROUPS"
          options={groupOptions}
          menuPlacement="auto"
          menuPortalTarget={document.body}
          menuShouldBlockScroll
        />
      </div>
    </>
  )
}

AddUserAccountTab.propTypes = propTypes

export default AddUserAccountTab
